/**
 * FilterPredicate — a user's filter choice → a SQL condition.
 * Pure module: no I/O. Returns fragments; it never touches a database.
 */

import type { MediaFilter, MediaItem } from '../types';

export interface SqlCondition {
  /** Always safe to concatenate — contains only placeholders, never user data. */
  where: string;
  params: (string | number)[];
}

export function toSql(projectId: number, filter: MediaFilter): SqlCondition {
  if (filter === 'all') {
    return { where: 'project_id = ?', params: [projectId] };
  }
  if (filter === 'unreviewed') {
    return { where: 'project_id = ? AND bucket_id IS NULL', params: [projectId] };
  }
  if (filter === 'reviewed') {
    return { where: 'project_id = ? AND bucket_id IS NOT NULL', params: [projectId] };
  }
  return { where: 'project_id = ? AND bucket_id = ?', params: [projectId, filter.bucketId] };
}

/** The same rule in memory — used by the UI to keep a list consistent after an edit. */
export function matches(item: MediaItem, filter: MediaFilter): boolean {
  if (filter === 'all') return true;
  if (filter === 'unreviewed') return item.bucketId === null;
  if (filter === 'reviewed') return item.bucketId !== null;
  return item.bucketId === filter.bucketId;
}

export function describe(filter: MediaFilter, bucketName?: string): string {
  if (filter === 'all') return 'All';
  if (filter === 'unreviewed') return 'Unreviewed';
  if (filter === 'reviewed') return 'Reviewed';
  return bucketName ?? 'Bucket';
}
